// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"PageContent--next-sr-only--64WSGKK","filterWidth":"PageContent--filterWidth--LI0qzNg"};